import TokenService from '@/services/token';
import AuthService from '@/services/auth';

const initialState = () => {
  return {
    user: null,
    loggingIn: false,
  };
};

export default {
  namespaced: true,
  state: initialState(),
  getters: {
    isAuthenticated: (state) => !!state.user,
    isLoggingIn: (state) => state.loggingIn,
  },
  mutations: {
    SET_USER: (state, payload) => {
      state.user = payload;
    },
    SET_LOGGING_IN: (state, payload) => {
      state.loggingIn = payload;
    },
    RESET(state) {
      const newState = initialState();
      Object.keys(newState).forEach((key) => {
        state[key] = newState[key];
      });
    },
  },
  actions: {
    async init({ dispatch, commit }) {
      dispatch('validate').then((user) => {
        if (user) {
          dispatch('profile/getProfile', {}, { root: true });
          commit('SET_USER', user);
        }
      });
    },
    async login(context, payload) {
      try {
        context.commit('SET_LOGGING_IN', true);

        await AuthService.login(payload.email, payload.password, payload.type);

        context.commit('SET_LOGGING_IN', false);

        const token = TokenService.getToken();
        if (token) {
          console.log('TOKEN', token);
          const decoded = TokenService.decode(token);
          context.commit('SET_USER', decoded);
          return decoded;
        }
      } catch (error) {
        context.commit('SET_LOGGING_IN', false);
        return Promise.reject(error.message);
      }
    },
    async validate({ commit }) {
      const token = TokenService.getToken();

      if (token) {
        const user = TokenService.decode(token);
        if (!user) {
          return null;
        }
        const isExpired = TokenService.isExpired(token);
        if (isExpired) {
          return null;
        }
        commit('SET_USER', user);
        return user;
      } else {
        commit('SET_USER', null);
      }

      return null;
    },
    async setToken(context, token) {
      context.commit('SET_USER', TokenService.decode(token));
    },
    async logout(context) {
      TokenService.removeToken();
      context.commit('SET_USER', null);
    },
    async reset(context) {
      context.commit('RESET');
    },
  },
};
